import { DecisionReason } from "../../../../model/model"
import { EvaluatorContext, EvaluatorRequest } from "../../Evaluator"
import { InAppMessageEligibilityEvaluation } from "./InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityRequest } from "./InAppMessageEligibilityRequest"
import { InAppMessageEligibilityFlow } from "./InAppMessageEligibilityFlowEvaluator"
import { EvaluationEventRecorder } from "../../EvaluationEventRecorder"
import { InAppMessageEvaluator } from "../InAppMessageEvaluator"

export class InAppMessageEligibilityEvaluator extends InAppMessageEvaluator<
  InAppMessageEligibilityRequest,
  InAppMessageEligibilityEvaluation
> {
  constructor(
    private readonly evaluationFlow: InAppMessageEligibilityFlow,
    private readonly eventRecorder: EvaluationEventRecorder
  ) {
    super()
  }

  /**
   * @override
   */
  public supports(request: EvaluatorRequest): request is InAppMessageEligibilityRequest {
    return (request as InAppMessageEligibilityRequest).inAppMessage !== undefined
  }

  /**
   * @override
   */
  public evaluateInternal(
    request: InAppMessageEligibilityRequest,
    context: EvaluatorContext
  ): InAppMessageEligibilityEvaluation {
    return (
      this.evaluationFlow.evaluate(request, context) ??
      InAppMessageEligibilityEvaluation.ineligible(request, context, DecisionReason.NOT_IN_IN_APP_MESSAGE_TARGET)
    )
  }

  /**
   * @override
   */
  public record(request: InAppMessageEligibilityRequest, evaluation: InAppMessageEligibilityEvaluation): void {
    this.eventRecorder.record(request, evaluation)

    // evaluation which is ineligible with nonnullable layout evaluation means that message is deduplicated or hidden.
    // for preventing imbalance, we should record layout evaluation tracking exposure event.
    if (!evaluation.isEligible && evaluation.layoutEvaluation !== null) {
      this.eventRecorder.record(evaluation.layoutEvaluation.request, evaluation.layoutEvaluation)
    }
  }
}
